import * as React from 'react';
import { Path } from 'react-native-svg';
import { Icon, IIconProps } from 'native-base';

const SvgQuestionCircle = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Path d="M10 1.25a8.75 8.75 0 10.001 17.501A8.75 8.75 0 0010 1.25zm0 16.016a7.267 7.267 0 010-14.532 7.267 7.267 0 010 14.532z" />
      <Path d="M12.18 6.186A3.293 3.293 0 0010 5.39c-.82 0-1.594.283-2.18.795-.61.533-.945 1.25-.945 2.017v.149c0 .085.07.156.156.156h.938c.086 0 .156-.07.156-.156v-.149c0-.861.842-1.562 1.875-1.562s1.875.7 1.875 1.562c0 .608-.43 1.164-1.096 1.42a2.183 2.183 0 00-1.406 2.067v.42c0 .085.07.156.156.156h.938c.086 0 .156-.07.156-.157v-.443a.945.945 0 01.604-.875c1.152-.443 1.896-1.459 1.896-2.588.002-.767-.334-1.484-.943-2.017zm-2.961 8.11a.781.781 0 101.562 0 .781.781 0 00-1.562 0z" />
    </Icon>
  );
};

export default SvgQuestionCircle;
